module.exports = __webpack_public_path__ + "media/images/countrysquared/om-48a243646aaa23477d22fe298f3e0bdc.svg";